"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootStore = void 0;
var is_before_1 = __importDefault(require("date-fns/is_before"));
var is_valid_1 = __importDefault(require("date-fns/is_valid"));
var merge_1 = __importDefault(require("lodash/merge"));
var mobx_1 = require("mobx");
var ms_1 = __importDefault(require("ms"));
var api_1 = __importDefault(require("../core/api"));
var constants_1 = __importDefault(require("../core/constants"));
var translations_1 = require("../translations");
var utils_1 = require("../utils");
var composer_1 = __importDefault(require("./composer"));
var view_1 = __importDefault(require("./view"));
(0, translations_1.initializeLocale)();
var chosenLocale = (0, translations_1.getUserLocale)();
var RootStore = /** @class */ (function () {
    function RootStore(_a) {
        var fullscreen = _a.fullscreen;
        this.conversations = [];
        this.isBotTyping = mobx_1.observable.box(false);
        this.botUILanguage = chosenLocale;
        this.delayedMessages = [];
        this.composer = new composer_1.default(this);
        this.view = new view_1.default(this, fullscreen);
    }
    RootStore.prototype.setIntlProvider = function (provider) {
        this.intl = provider;
    };
    Object.defineProperty(RootStore.prototype, "isConversationStarted", {
        get: function () {
            var _a;
            return !!((_a = this.currentConversation) === null || _a === void 0 ? void 0 : _a.messages.length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "botName", {
        get: function () {
            var _a, _b;
            return ((_a = this.config) === null || _a === void 0 ? void 0 : _a.botName) || ((_b = this.botInfo) === null || _b === void 0 ? void 0 : _b.name) || 'Bot';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "alwaysScrollDownOnMessages", {
        get: function () {
            return this.botInfo.alwaysScrollDownOnMessages || false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "isEmulator", {
        get: function () {
            var _a;
            return ((_a = this.config) === null || _a === void 0 ? void 0 : _a.isEmulator) || false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "hasBotInfoDescription", {
        get: function () {
            var _a;
            return !!((_a = this.config.botConvoDescription) === null || _a === void 0 ? void 0 : _a.length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "botAvatarUrl", {
        get: function () {
            var _a, _b, _c;
            return (((_b = (_a = this.botInfo) === null || _a === void 0 ? void 0 : _a.details) === null || _b === void 0 ? void 0 : _b.avatarUrl) ||
                ((_c = this.config) === null || _c === void 0 ? void 0 : _c.avatarUrl) ||
                (this.config.isEmulator && "".concat(window.ROOT_PATH, "/assets/modules/channel-web/images/emulator-default.svg")));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "rtl", {
        get: function () {
            return (0, utils_1.isRTLLocale)(this.preferredLanguage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "escapeHTML", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.botInfo) === null || _a === void 0 ? void 0 : _a.security) === null || _b === void 0 ? void 0 : _b.escapeHTML;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "currentMessages", {
        get: function () {
            var _a;
            return (_a = this.currentConversation) === null || _a === void 0 ? void 0 : _a.messages;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RootStore.prototype, "currentConversationId", {
        get: function () {
            var _a;
            return (_a = this.currentConversation) === null || _a === void 0 ? void 0 : _a.id;
        },
        enumerable: false,
        configurable: true
    });
    RootStore.prototype.postMessage = function (name, payload) {
        var chatId = this.config.chatId;
        window.parent.postMessage({ name: name, chatId: chatId, payload: payload }, '*');
    };
    RootStore.prototype.updateMessages = function (messages) {
        this.currentConversation.messages = messages;
    };
    RootStore.prototype.clearMessages = function () {
        this.currentConversation.messages = [];
    };
    RootStore.prototype.deleteConversation = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.currentConversation !== undefined && this.currentConversation.messages.length > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.api.deleteMessages(this.currentConversationId)];
                    case 1:
                        _a.sent();
                        this.clearMessages();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    RootStore.prototype.loadEventInDebugger = function (messageId, isManual) {
        return __awaiter(this, void 0, void 0, function () {
            var messages;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.config.isEmulator || !messageId) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.api.listByIncomingEvent(messageId)];
                    case 1:
                        messages = _a.sent();
                        this.view.setHighlightedMessages(messages);
                        window.parent.postMessage({ action: 'load-event', payload: { messageId: messageId, isManual: isManual } }, '*');
                        return [2 /*return*/];
                }
            });
        });
    };
    RootStore.prototype.addEventToConversation = function (event) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var message;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.isInitialized && this.currentConversationId !== event.conversationId)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.fetchConversations()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.fetchConversation(event.conversationId)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                    case 3:
                        // Autoplay bot voice messages
                        if (((_a = event.payload) === null || _a === void 0 ? void 0 : _a.type) === 'voice' && !event.authorId) {
                            event.payload.autoPlay = true;
                        }
                        message = __assign(__assign({}, event), { conversationId: event.conversationId });
                        if (this.isBotTyping.get() && !event.authorId) {
                            this.delayedMessages.push({ message: message, showAt: this.currentConversation.typingUntil });
                        }
                        else {
                            this.currentConversation.messages.push(message);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    RootStore.prototype.updateTyping = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var start;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.isInitialized && this.currentConversationId !== event.conversationId)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.fetchConversations()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchConversation(event.conversationId)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                    case 3:
                        start = new Date();
                        if ((0, is_before_1.default)(start, this.currentConversation.typingUntil)) {
                            start = this.currentConversation.typingUntil;
                        }
                        this.currentConversation.typingUntil = new Date(+start + event.timeInMs);
                        this._startTypingTimer();
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Loads the initial state, for the first time or when the user ID is changed. */
    RootStore.prototype.initializeChat = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 5]);
                        return [4 /*yield*/, this.fetchConversations()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.fetchConversation(this.config.conversationId)];
                    case 2:
                        _a.sent();
                        (0, mobx_1.runInAction)('-> setInitialized', function () {
                            _this.isInitialized = true;
                            _this.postMessage('webchatReady');
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        console.error('Error while fetching data, creating new convo...', err_1);
                        return [4 /*yield*/, this.createConversation()];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 5: return [4 /*yield*/, this.fetchPreferences()];
                    case 6:
                        _a.sent();
                        return [4 /*yield*/, this.sendUserVisit()];
                    case 7:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RootStore.prototype.fetchBotInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var botInfo;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.fetchBotInfo()];
                    case 1:
                        botInfo = _a.sent();
                        (0, mobx_1.runInAction)('-> setBotInfo', function () {
                            _this.botInfo = botInfo;
                        });
                        this.mergeConfig({
                            extraStylesheet: botInfo.extraStylesheet,
                            disableNotificationSound: botInfo.disableNotificationSound
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    RootStore.prototype.fetchPreferences = function () {
        return __awaiter(this, void 0, void 0, function () {
            var preferences;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.fetchPreferences()];
                    case 1:
                        preferences = _a.sent();
                        if (!preferences.language) {
                            return [2 /*return*/];
                        }
                        (0, mobx_1.runInAction)('-> setPreferredLanguage', function () {
                            _this.updateBotUILanguage(preferences.language);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Fetches the list of conversation, and update the corresponding config values */
    RootStore.prototype.fetchConversations = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, conversations, recentConversationLifetime, startNewConvoOnTimeout;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.api.fetchConversations()];
                    case 1:
                        _a = _b.sent(), conversations = _a.conversations, recentConversationLifetime = _a.recentConversationLifetime, startNewConvoOnTimeout = _a.startNewConvoOnTimeout;
                        (0, mobx_1.runInAction)('-> setConversations', function () {
                            if (!conversations.length) {
                                _this.view.showBotInfo();
                            }
                            _this.config.recentConversationLifetime = recentConversationLifetime;
                            _this.config.startNewConvoOnTimeout = startNewConvoOnTimeout;
                            _this.conversations = conversations;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Fetch the specified conversation ID, or try to fetch a valid one from the list */
    RootStore.prototype.fetchConversation = function (convoId) {
        return __awaiter(this, void 0, void 0, function () {
            var conversationId, conversation;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        conversationId = convoId || this._getCurrentConvoId();
                        if (!conversationId) {
                            return [2 /*return*/, this.createConversation()];
                        }
                        return [4 /*yield*/, this.api.fetchConversation(convoId || this._getCurrentConvoId())];
                    case 1:
                        conversation = _a.sent();
                        if (!(conversation === null || conversation === void 0 ? void 0 : conversation.messages.length)) return [3 /*break*/, 3];
                        conversation.messages = conversation.messages.sort(function (a, b) { return new Date(a.sentOn).getTime() - new Date(b.sentOn).getTime(); });
                        return [4 /*yield*/, this.extractFeedback(conversation.messages)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        (0, mobx_1.runInAction)('-> setConversation', function () {
                            _this.currentConversation = conversation;
                            _this.view.hideConversations();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Sends the specified message, or fetch the message in the composer */
    RootStore.prototype.sendMessage = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var userMessage, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (message) {
                            return [2 /*return*/, this.sendData({ type: 'text', text: message })];
                        }
                        userMessage = this.composer.message;
                        if (!userMessage || !userMessage.length) {
                            return [2 /*return*/];
                        }
                        this.composer.updateMessage('');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.sendData({ type: 'text', text: userMessage })];
                    case 2:
                        _a.sent();
                        (0, utils_1.trackMessage)('sent');
                        this.composer.addMessageToHistory(userMessage);
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.composer.updateMessage(userMessage);
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /** Sends an event to start conversation & hide the bot info page */
    RootStore.prototype.startConversation = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendData({ type: 'request_start_conversation' })];
                    case 1:
                        _a.sent();
                        this.view.toggleBotInfo();
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Creates a new conversation and switches to it */
    RootStore.prototype.createConversation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var newId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.createConversation()];
                    case 1:
                        newId = _a.sent();
                        return [4 /*yield*/, this.fetchConversations()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.fetchConversation(newId)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, newId];
                }
            });
        });
    };
    RootStore.prototype.setReference = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.setReference(this.config.reference, this.currentConversationId)];
            });
        });
    };
    RootStore.prototype.resetConversation = function () {
        this.currentConversation = undefined;
    };
    RootStore.prototype.resetSession = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.composer.setLocked(false);
                return [2 /*return*/, this.api.resetSession(this.currentConversationId)];
            });
        });
    };
    RootStore.prototype.sendUserVisit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendData({
                            type: 'visit',
                            text: 'User visit',
                            timezone: -(new Date().getTimezoneOffset() / 60),
                            language: (0, translations_1.getUserLocale)()
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RootStore.prototype.extractFeedback = function (messages) {
        return __awaiter(this, void 0, void 0, function () {
            var feedbackMessageIds, feedbackInfo;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        feedbackMessageIds = messages.filter(function (x) { return x.payload && x.payload.collectFeedback; }).map(function (x) { return x.id; });
                        if (!feedbackMessageIds.length) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.api.getMessageIdsFeedbackInfo(feedbackMessageIds)];
                    case 1:
                        feedbackInfo = _a.sent();
                        (0, mobx_1.runInAction)('-> setFeedbackInfo', function () {
                            _this.messageFeedbacks = feedbackInfo;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    RootStore.prototype.sendFeedback = function (feedback, messageId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.sendFeedback(feedback, messageId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RootStore.prototype.downloadConversation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, txt, name_1, blobFile, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.downloadConversation(this.currentConversationId)];
                    case 1:
                        _a = _b.sent(), txt = _a.txt, name_1 = _a.name;
                        blobFile = new Blob([txt]);
                        (0, utils_1.downloadFile)(name_1, blobFile);
                        return [3 /*break*/, 3];
                    case 2:
                        err_2 = _b.sent();
                        console.error('Error trying to download conversation');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /** Sends an event or a message, depending on how the backend manages those types */
    RootStore.prototype.sendData = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isInitialized) {
                            console.warn('[webchat] Cannot send data until the webchat is ready');
                            return [2 /*return*/];
                        }
                        if (!constants_1.default.MESSAGE_TYPES.includes(data.type)) {
                            return [2 /*return*/, this.api.sendEvent(data, this.currentConversationId)];
                        }
                        return [4 /*yield*/, this.api.sendMessage(data, this.currentConversationId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RootStore.prototype.uploadFile = function (title, payload, file) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.uploadFile(file, payload, this.currentConversationId)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Sends a message of type voice */
    RootStore.prototype.sendVoiceMessage = function (voice, ext) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.sendVoiceMessage(voice, ext, this.currentConversationId)];
            });
        });
    };
    /** Use this method to replace a value or add a new config */
    RootStore.prototype.mergeConfig = function (config) {
        this.config = (0, merge_1.default)(this.config, config);
        this._applyConfig();
    };
    /** This replaces all the configurations by this object */
    RootStore.prototype.updateConfig = function (config, bp) {
        this.config = config;
        if (!this.api) {
            this.bp = bp;
            this.api = new api_1.default(bp.axios);
        }
        this._applyConfig();
    };
    RootStore.prototype._applyConfig = function () {
        this.config.layoutWidth && this.view.setLayoutWidth(this.config.layoutWidth);
        this.config.containerWidth && this.view.setContainerWidth(this.config.containerWidth);
        this.view.disableAnimations = this.config.disableAnimations;
        this.config.showPoweredBy ? this.view.showPoweredBy() : this.view.hidePoweredBy();
        document.title = this.config.botName || window.APP_NAME;
        if (window.APP_FAVICON) {
            var link = document.querySelector('link[rel="icon"]');
            link && link.setAttribute('href', window.APP_FAVICON);
        }
        if (window.APP_CUSTOM_CSS) {
            var sheet = document.createElement('link');
            sheet.rel = 'stylesheet';
            sheet.href = window.APP_CUSTOM_CSS;
            sheet.type = 'text/css';
            document.head.appendChild(sheet);
        }
        this.api.updateAxiosConfig({ botId: this.config.botId, externalAuthToken: this.config.externalAuthToken });
        if (!this.isInitialized) {
            window.USE_SESSION_STORAGE = this.config.useSessionStorage;
        }
        else if (window.USE_SESSION_STORAGE !== this.config.useSessionStorage) {
            console.warn('[WebChat] "useSessionStorage" value cannot be altered once the webchat is initialized');
        }
        var locale = this.config.locale ? (0, translations_1.getUserLocale)(this.config.locale) : chosenLocale;
        this.updateBotUILanguage(locale);
        document.documentElement.setAttribute('lang', locale);
        this.publishConfigChanged();
    };
    RootStore.prototype.setCustomUserId = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.api.setCustomUserId(userId)];
            });
        });
    };
    RootStore.prototype.publishConfigChanged = function () {
        this.postMessage('configChanged', JSON.stringify(this.config, undefined, 2));
    };
    RootStore.prototype.setMessageWrapper = function (messageWrapper) {
        this.messageWrapper = messageWrapper;
    };
    RootStore.prototype.updatePreferredLanguage = function (lang) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.updateBotUILanguage(lang);
                        this.preferredLanguage = lang;
                        return [4 /*yield*/, this.api.updateUserPreferredLanguage(lang)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /** Starts a timer to remove the typing animation when it's completed */
    RootStore.prototype._startTypingTimer = function () {
        var _this = this;
        if (this._typingInterval) {
            return;
        }
        this.isBotTyping.set(true);
        this._typingInterval = setInterval(function () {
            var typeUntil = new Date(_this.currentConversation && _this.currentConversation.typingUntil);
            if (!typeUntil || !(0, is_valid_1.default)(typeUntil) || (0, is_before_1.default)(typeUntil, new Date())) {
                _this._expireTyping();
            }
            else {
                _this.emptyDelayedMessagesQueue(false);
            }
        }, 50);
    };
    RootStore.prototype._expireTyping = function () {
        this.emptyDelayedMessagesQueue(true);
        this.isBotTyping.set(false);
        this.currentConversation.typingUntil = undefined;
        clearInterval(this._typingInterval);
        this._typingInterval = undefined;
    };
    RootStore.prototype.updateBotUILanguage = function (lang) {
        var _this = this;
        lang = (0, translations_1.getUserLocale)(lang); // Ensure language is supported
        (0, mobx_1.runInAction)('-> setBotUILanguage', function () {
            var _a;
            _this.botUILanguage = lang;
            _this.preferredLanguage = lang;
            (_a = window.BP_STORAGE) === null || _a === void 0 ? void 0 : _a.set('bp/channel-web/user-lang', lang);
        });
    };
    RootStore.prototype.emptyDelayedMessagesQueue = function (removeAll) {
        while (this.delayedMessages.length) {
            var message = this.delayedMessages[0];
            if (removeAll || (0, is_before_1.default)(message.showAt, new Date())) {
                this.currentConversation.messages.push(message.message);
                this.delayedMessages.shift();
            }
            else {
                break;
            }
        }
    };
    /** Returns the current conversation ID, or the last one if it didn't expired. Otherwise, returns nothing. */
    RootStore.prototype._getCurrentConvoId = function () {
        var _a;
        if (this.currentConversationId) {
            return this.currentConversationId;
        }
        if (!this.conversations.length) {
            return;
        }
        var lifeTimeMargin = Date.now() - (0, ms_1.default)(this.config.recentConversationLifetime);
        var isConversationExpired = new Date(((_a = this.conversations[0].lastMessage) === null || _a === void 0 ? void 0 : _a.sentOn) || this.conversations[0].createdOn).getTime() < lifeTimeMargin;
        if (isConversationExpired && this.config.startNewConvoOnTimeout) {
            return;
        }
        return this.conversations[0].id;
    };
    __decorate([
        mobx_1.observable
    ], RootStore.prototype, "conversations", void 0);
    __decorate([
        mobx_1.observable
    ], RootStore.prototype, "currentConversation", void 0);
    __decorate([
        mobx_1.observable
    ], RootStore.prototype, "botInfo", void 0);
    __decorate([
        mobx_1.observable
    ], RootStore.prototype, "config", void 0);
    __decorate([
        mobx_1.observable
    ], RootStore.prototype, "preferredLanguage", void 0);
    __decorate([
        mobx_1.observable
    ], RootStore.prototype, "isInitialized", void 0);
    __decorate([
        mobx_1.observable
    ], RootStore.prototype, "messageFeedbacks", void 0);
    __decorate([
        mobx_1.observable
    ], RootStore.prototype, "messageWrapper", void 0);
    __decorate([
        mobx_1.observable
    ], RootStore.prototype, "botUILanguage", void 0);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "setIntlProvider", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "isConversationStarted", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "botName", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "alwaysScrollDownOnMessages", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "isEmulator", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "hasBotInfoDescription", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "botAvatarUrl", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "rtl", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "escapeHTML", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "currentMessages", null);
    __decorate([
        mobx_1.computed
    ], RootStore.prototype, "currentConversationId", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "postMessage", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "updateMessages", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "clearMessages", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "deleteConversation", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "loadEventInDebugger", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "addEventToConversation", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "updateTyping", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "initializeChat", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "fetchBotInfo", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "fetchPreferences", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "fetchConversations", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "fetchConversation", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "sendMessage", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "startConversation", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "createConversation", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "setReference", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "resetConversation", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "resetSession", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "sendUserVisit", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "extractFeedback", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "sendFeedback", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "downloadConversation", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "sendData", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "uploadFile", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "sendVoiceMessage", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "mergeConfig", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "updateConfig", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "setCustomUserId", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "publishConfigChanged", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "setMessageWrapper", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "updatePreferredLanguage", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "_startTypingTimer", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "_expireTyping", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "updateBotUILanguage", null);
    __decorate([
        mobx_1.action.bound
    ], RootStore.prototype, "emptyDelayedMessagesQueue", null);
    return RootStore;
}());
exports.RootStore = RootStore;
